// import { pixels } from "../../../projects/CreateNewProject";
// import WoodTable from "./WoodTable";
import WoodPrint from "./WoodPrint";
import { useReactToPrint } from "react-to-print";
import { useRef, useState } from "react";
import styled from "styled-components";
import useMaterials from "../../useMaterials";
import { condenseMaterials } from "../../calculations";

const Container = styled.div`
  padding: 0px;
  display: flex;
  position: relative;
  justify-content: space-between;
`;

const Paper = styled.div`
  box-shadow: 5px 5px 15px 5px rgb(159 159 159 / 28%);
  min-width: 80%;
  border: 1px solid lightgrey;
  margin: 3px;
  @media print {
    border: 1px solid transparent;
    box-shadow: none;
  }
`;

const Save = styled.button`
  position: absolute;
  right: 0;
  top: 0;
  margin: 20px;
`;

const OrderForm = styled.div`
  flex-grow: 2;
  margin-right: 10px;
  background: white;
  box-shadow: 5px 5px 15px 5px rgb(159 159 159 / 28%);
  padding: 15px;
  margin: 3px;
  border: 1px solid lightgrey;
`;

const Button = styled.div`
  border: 1px solid black;
  cursor: pointer;
  color: white;
  text-align: center;
  padding: 5px;
  border-radius: 3px;
  background: black;
  &:hover {
    background: white;
    color: black;
  }
`;

const Item = styled.div`
  margin-bottom: 20px;
  align-items: center;
  gap: 15px;
  input,
  textarea {
    border-radius: 3px !important;
    border: 2px solid lightgrey;
  }
  label {
    text-transform: uppercase;
    color: lightgrey;
    font-weight: 700;
  }
  textarea {
    height: 200px;
  }
`;

const Header = styled.div``;

const item = {
  type: "",
  board: "",
  length: "",
  amount: "",
  purpose: "",
};

function WoodOrder({ handleProjectEdit, project }) {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const defaultMaterials = useMaterials(project.walls, project);

  const setDefault = () => {
    console.log(defaultMaterials);
    handleProjectEdit("materials", defaultMaterials);
    setMaterials(defaultMaterials);
  };
  const setSpecificDefault = (m, id) => {
    let newMaterials = [...materials];
    let material = { ...newMaterials.filter((e) => e.id === id)[0] };
    let index = newMaterials.indexOf(
      newMaterials.filter((e) => e.id === id)[0]
    );
    material.amount = defaultMaterials[index].amount;
    newMaterials[index] = material;
    handleProjectEdit("materials", newMaterials);
  };

  const setSpecificCustom = (e, id) => {
    let newMaterials = [...materials];
    let material = { ...newMaterials.filter((e) => e.id === id)[0] };

    let index = newMaterials.indexOf(
      newMaterials.filter((e) => e.id === id)[0]
    );
    material[e.target.id] = e.target.value;
    newMaterials[index] = material;
    handleProjectEdit("materials", newMaterials);
  };

  const setHeaderItems = (name, value) => {
    handleProjectEdit(name, value);
  };

  const removeMaterial = (m, id) => {
    let newMaterials = [...materials];
    let material = { ...newMaterials.filter((e) => e.id === id)[0] };
    let index = newMaterials.indexOf(
      newMaterials.filter((e) => e.id === id)[0]
    );
    console.log(index, material);

    material.remove = !material.remove;
    newMaterials[index] = material;
    setMaterials(newMaterials);
    handleProjectEdit("materials", newMaterials);
  };

  const addItem = () => {
    let newMaterials = [...project.materials];
    newMaterials.push(item);
  };
  const [date, setDate] = useState(project.orderDate);
  const [notes, setNotes] = useState(project.orderNotes);
  const [materials, setMaterials] = useState(project.materials);

  const setCondensedMaterials = () => {
    setMaterials(condenseMaterials(materials));
  };

  return (
    <Container>
      <Save onClick={handlePrint}>Save</Save>
      <OrderForm>
        <Header>
          <Item>
            <Button onClick={() => setDefault()}>Set All Default</Button>
          </Item>
          <Item>
            <Button onClick={() => setCondensedMaterials()}>
              Condense Materials
            </Button>
          </Item>
          <Item>
            <label>Date needed</label>
            <input
              className="form-control"
              type="date"
              onChange={(e) => setDate(e.target.value)}
              onBlur={() => setHeaderItems("orderDate", date)}
              defaultValue={date}
            />
          </Item>
          <Item>
            <label>Notes</label>
            <textarea
              className="form-control"
              onChange={(e) => setNotes(e.target.value)}
              onBlur={() => setHeaderItems("orderNotes", notes)}
              defaultValue={notes}
            />
          </Item>
        </Header>
      </OrderForm>

      <Paper ref={componentRef}>
        <WoodPrint
          setSpecificCustom={setSpecificCustom}
          yurtTrait={project}
          walls={project.walls}
          materials={materials}
          date={date}
          notes={notes}
          setSpecificDefault={setSpecificDefault}
          addItem={addItem}
          removeMaterial={removeMaterial}
        />
      </Paper>
    </Container>
  );
}

export default WoodOrder;
